import { isValidEmail } from "./validationUtils";

export const CHAT_NOTIFICATION_REPLY_TO_PREFERENCE_NAME = "chat-notification-reply-to-email";
export const DEFAULT_CHAT_NOTIFICATION_REPLY_TO_EMAIL = "support@ambifi.com";

export function normalizeChatNotificationReplyToEmail(value) {
	const normalized = value === null || value === undefined ? "" : String(value).trim();

	if (normalized === "") {
		return "";
	}

	if (normalized.length > 254 || /[\r\n]/.test(normalized) || !isValidEmail(normalized)) {
		return null;
	}

	return normalized;
}
